import { Card, InfoRow } from './BmsCardPrimitives'

const ConfigsCard = ({ bms, className = '' }) => (
  <Card className={className}>
    <InfoRow label="Protocol" value={bms.protocol} />
    <InfoRow label="MCU Type" value={bms.mcuType} />
  </Card>
)

export default ConfigsCard
